import React from 'react';
import {
  formatTradeValue,
} from '../../numberFormatters';
import {
  decideColorForNode,
} from '../chart/Utils';
import {
  defaultLinkStrokeColor,
} from '../Utils';
import NodeLabels from './NodeLabels';
import {
  bottomMargin,
  IExportInput as IProps,
  leftMargin,
  rightMargin,
  topMargin,
} from './Utils';

export default class extends React.Component<IProps> {
  render() {
    const {
      width, height, exportType,
      texts, nodes, links, total,
    } = this.props;

    const fullWidth = width + leftMargin + rightMargin;
    const fullHeight = height + topMargin + bottomMargin;
    const centeringTransform = `translate(${width / 2 + leftMargin} ${height / 2 + topMargin})`;

    const nodeElems = nodes.map(node => {
      const {id, color, isActive, x, y, radius} = node;
      const fill = decideColorForNode(
        id, undefined, color, isActive, node.isCurrentlyExported,
      );
      return (
        <circle cx={x} cy={y} r={radius} fill={fill} key={id}/>
      );
    });

    const linkElems = links.map(link => {
      const {path, source, target} = link;
      return (
        <path
          d={path} strokeWidth={1}
          stroke={defaultLinkStrokeColor} fill='none'
          key={`${source.id}-${target.id}`}/>
      );
    });

    // Total:
    const totalElem = (
      <text x={leftMargin + width / 2} y={topMargin / 2}>
        {formatTradeValue(total)}
      </text>
    );
    return (
      <svg viewBox={`0 0 ${fullWidth} ${fullHeight}`} xmlns='http://www.w3.org/2000/svg'>
        {totalElem}
        <g transform={centeringTransform}>
          {linkElems}
          {nodeElems}
          <NodeLabels texts={texts} exportType={exportType}/>
        </g>
      </svg>
    );
  }
}
